<rask-container-block>
    <ng-container header>
        {{'KUNDORDER_LEVRADER_HEADER_FORSORJNINGSGRADER' | translate}}
        <rask-action-button
            [disabled]="!canEdit" icon="fas fa-plus" (click)="addForsorjningskalla()"
            aid="buttonAddForsorjningskalla">
            {{ 'KUNDORDER_DETAIL_FORSORJNINGSRAD_ADD' | translate }}
        </rask-action-button>
    </ng-container>
    <form class="no-panel-body">
        <div class="w-100 jlp-container-location" style="padding:0 !important">
            <rask-date-drill-down [periodFrom]="orderrad.periodFrom" [periodTom]="orderrad.periodTom" [parent]="this">
                <rask-hot-doc [canEdit]="canEdit" [hotDoc]="hotDoc"></rask-hot-doc>
            </rask-date-drill-down>
        </div>
    </form>
</rask-container-block>
